<template>
    <div id="agreementContainer">
        <div id="agreement">
            <div v-html="agreementText"></div>
        </div>
        <div>
            <input 
                type="checkbox" 
                id="terms-conditions"
                required="required"
                :checked="isChecked"
                @change="setIsAgreementAccepted()">
            <label for="terms-conditions" id="confirmation">{{ confirmationText }}</label>
        </div>
    </div>
    
</template>

<script>
export default {
    props: {
        agreementText: {
            type: String,
            required: true
        },
        confirmationText: {
            type: String,
            required: true
        }

    },
    data() {
        return {
            isChecked: false
        }
    },
    methods: {
        setIsAgreementAccepted() {
            this.isChecked = !this.isChecked;
        },
    }
}
</script>

<style scoped>
    #agreementContainer {
        padding: 0px 11px;
    }

    #confirmation {
        display: inline;
    }

    #agreement {
        overflow-x: hidden;
        overflow-y: auto;
        height: 200px;
        margin: 40px auto;
        padding: 35px;
        border: 1px solid #bbb;
        background-color: #f8f8f8;
        border-radius: 2px; 
    }

    #agreement h6 {
        margin-top: 50px;
    }
</style>
